import { Routes } from '@angular/router';
import { InjectionToken } from '@angular/core';

export interface MdcInventoryConfig {
  strategy?: MdcInventoryStrategy;
  sumUp?: boolean | { visible: boolean; editable: boolean };
}

export interface MdcInventoryStrategy {
  createSetupRoutes(config?: MdcInventoryConfig): Promise<Routes>;
}

export const SOFTLINE_CONFIG_MDC_INVENTORY = new InjectionToken<MdcInventoryConfig>(
  'SOFTLINE_CONFIG_MDC_INVENTORY',
  {
    factory: () => ({
      sumUp: true,
      strategy: new DefaultMdcInventoryStrategy(),
    }),
  }
);

export const MDC_INVENTORY_STRATEGY = new InjectionToken<MdcInventoryStrategy>(
  'MdcInventoryStrategy'
);

export class DefaultMdcInventoryStrategy implements MdcInventoryStrategy {
  async createSetupRoutes(config?: MdcInventoryConfig): Promise<Routes> {
    return [];
  }
}
